import { Component } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

class InAppNotification extends Component {
  state = {
    open: false,
    inAppNotificationData: {},
  };

  audio = new Audio("/assets/audio/customer-notification.mp3");

  /**
   * 🔔 This method is called externally (from App / Redux / event bus)
   */
  showNotification = (payload) => {
    if (!payload) return;

    const data = payload.data || payload.notification || payload;

    // 🔔 Play sound (safe)
    this.audio.currentTime = 0;
    this.audio.play().catch(() => {});

    // 📳 Vibrate
    if ("vibrate" in navigator) {
      navigator.vibrate([100, 150, 100]);
    }

    this.setState({
      open: true,
      inAppNotificationData: {
        title: data.title,
        message: data.message || data.body,
        image: data.image,
        click_action: data.click_action,
      },
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { inAppNotificationData, open } = this.state;

    return (
      <Dialog
        fullWidth
        open={open}
        onClose={this.handleClose}
        disableEscapeKeyDown
      >
        <DialogTitle>{inAppNotificationData.title}</DialogTitle>

        <DialogContent dividers>
          <p className="mb-2">{inAppNotificationData.message}</p>

          {inAppNotificationData.image && (
            <img
              src={inAppNotificationData.image}
              className="img-fluid"
              alt=""
            />
          )}

          <div className="inAppNotificationActions mt-3">
            <button
              className={`btn inANClose ${
                inAppNotificationData.click_action ? "mr-2" : ""
              }`}
              onClick={this.handleClose}
            >
              {localStorage.getItem("inAppCloseButton")}
            </button>

            {inAppNotificationData.click_action && (
              <a
                className="btn inANLink"
                href={inAppNotificationData.click_action}
              >
                {localStorage.getItem("inAppOpenLinkButton")}
              </a>
            )}
          </div>

          <div className="alert-notify-bell">
            <i
              className="si si-bell"
              style={{ color: localStorage.getItem("storeColor") }}
            />
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default InAppNotification;
